// extracted by mini-css-extract-plugin
module.exports = {"versionLabel":"VersionLabel_versionLabel__3bhxQ"};